// Legacy JS module (verbatim TermsOfService content factory), no types: typed loosely below.
import termsPageContentDefault from 'root/src/client/web/static/TermsOfService/pageContent';
import { LegalPageLayout } from 'root/src/client/v2/_pages/legal/redesign/LegalPageLayout';
import { LegalProse } from 'root/src/client/v2/_pages/legal/redesign/LegalProse';
import { LegalSection } from 'root/src/client/v2/_pages/legal/redesign/LegalSection';
import { legalClasses } from 'root/src/client/v2/_pages/legal/redesign/legalClasses';
const termsPageContent = termsPageContentDefault;
// Terms of Service. REUSES the legacy `TermsOfService/pageContent` factory verbatim (legally
// significant text + the cross-section `<Anchor>` links to `section-4` / `section-5`), fed the
// redesign `legalClasses` map. The render mirrors the legacy index: each entry is a `<section id={id}>`
// with the `<h3>` title, the plain-English `{paragraph}` summary box, then the `{text}`; the trailing
// effective-date line is appended verbatim after the mapped sections.
export const RedesignTermsPage = () => {
    const sections = termsPageContent(legalClasses);
    return (<LegalPageLayout title="Terms of Service" effectiveDate="Effective February 1, 2025">
			<LegalProse>
				{sections.map(({ id, title, paragraph, text }) => (<LegalSection key={id !== null && id !== void 0 ? id : String(title)} id={id} title={title} summary={paragraph}>
						{text}
					</LegalSection>))}
				<p className={legalClasses.info}>
					These updated terms will go into effect on February 1, 2025, at 12 a.m. Eastern
					Time, and apply to all Dares launched on Dare Drop on or after that date.
				</p>
			</LegalProse>
		</LegalPageLayout>);
};
